import AdUserByPhone from "./AdUserByPhone"
import PasswordChange from "./PasswordChange"
import UserUnlock from "./UserUnlock"

const Helpers = () => (
    <>
        <span className="block text-center text-xs text-black/60">Necesitas ayuda?</span>
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
            <AdUserByPhone />
            <UserUnlock />
            <PasswordChange />
        </div>
    </>
)

export default Helpers
